import moment from 'moment';

// --------------------------------------------------------------------
// States builders

export const initSearchModelState = () => ({
  region: null,
  municipality: null,
  school: null,
});

/**
 * SchoolRecommendationModel
 */
export const initModelState = () => ({
  id: null,
  tapRequestTypeId: null,
  ...initSearchModelState(),
  alternatives: [],
  reason: null,
});

/**
 * @returns SchoolRecommendationAlternativeModel
 */
export const initAlternativesModelState = () => ({
  id: null,
  alternativeId: null,
  category: null,
  description: null,
  decision: 0,
  reason: null,
  reasonDate: null,
  numberOfStudents: 0,
  shortNameGrades: null,
});

// --------------------------------------------------------------------
// To Payloads Mappings

/**
 * @param {*} SchoolRecommendationModel
 * @returns SchoolRecommendationDto
 */
export const schoolRecommendationModelToDto = ({
  id,
  tapRequestTypeId,
  school: { id: schoolId },
  alternatives,
  reason,
}) => ({
  id,
  tapRequestTypeId,
  locationSchoolId: schoolId,
  reason,
  tapRequestSchoolAlternativeLocations: alternatives?.map(
    schoolRecommendationAlternativeModelToDto
  ),
});

/**
 *
 * @param {*} SchoolRecommendationAlternativeModel
 * @returns SchoolRecommendationAlternativeDto
 */
export const schoolRecommendationAlternativeModelToDto = ({
  id,
  alternativeId,
  reason,
  reasonDate,
  decision,
  numberOfStudents,
  studentCapacity,
  shortNameGrades,
}) => ({
  id,
  alternativeId,
  reason,
  reasonDate,
  decision,
  numberOfStudents,
  studentCapacity,
  shortNameGrades,
});

// --------------------------------------------------------------------
// To Models Mappings

/**
 *
 * @param {*} SchoolRecommendationReturnDto
 * @returns SchoolRecommendationModel
 */
export const schoolRecommendationReturnDtoToModel = ({
  id,
  tapRequestTypeId,
  region,
  municipality,
  locationSchool,
  reason,
  tapRequestSchoolAlternativeLocations,
}) => ({
  id,
  tapRequestTypeId,
  region,
  municipality,
  school: locationSchool,
  alternatives: tapRequestSchoolAlternativeLocations?.map(
    schoolRecommendationAlternativeReturnDtoToModel
  ),
  reason,
});

/**
 *
 * @param {*} SchoolRecommendationAlternativeReturnDto
 * @returns SchoolRecommendationAlternativeModel
 */
export const schoolRecommendationAlternativeReturnDtoToModel = ({
  id,
  reason,
  reasonDate,
  decision,
  tapSchoolAlternativeLocation: {
    alternativeLocation: { id: alternativeId, category, name },
    description,
    numberOfStudents,
    studentCapacity,
    shortNameGrades,
  },
}) => ({
  id,
  alternativeId,
  category,
  description,
  name,
  decision,
  reason,
  reasonDate: moment(reasonDate).format('DD-MMM-YYYY'),
  numberOfStudents,
  studentCapacity,
  shortNameGrades,
});

/**
 *
 * @param {*} SchoolAlternativeDto
 * @returns Partial<SchoolRecommendationAlternativeModel>
 */
export const schoolAlternativeDtoToModel = ({
  id,
  alternativeLocationId,
  alternativeLocation: { category, name },
  description,
  numberOfStudents,
  studentCapacity,
  shortNameGrades,
}) => ({
  id,
  alternativeId: alternativeLocationId,
  category,
  name,
  description,
  numberOfStudents,
  studentCapacity,
  shortNameGrades,
});
